import { render, staticRenderFns } from "./SAMPLE.vue?vue&type=template&id=ee2366f8&scoped=true&"
import script from "./SAMPLE.vue?vue&type=script&lang=js&"
export * from "./SAMPLE.vue?vue&type=script&lang=js&"
import style0 from "./SAMPLE.vue?vue&type=style&index=0&id=ee2366f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2366f8",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QToolbarTitle,QCard,QCardSection,QSpace,QSelect,QBtn,QList,QItem,QItemSection,QItemLabel,QPagination,QInnerLoading,QSpinnerGears,Ripple} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QToolbarTitle,QCard,QCardSection,QSpace,QSelect,QBtn,QList,QItem,QItemSection,QItemLabel,QPagination,QInnerLoading,QSpinnerGears}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
